"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _autoBind = _interopRequireDefault(require("auto-bind"));

var _marshaler = _interopRequireDefault(require("../util/marshaler"));

// Copyright © 2022 The Things Network Foundation, The Things Industries B.V.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var Sessions = /*#__PURE__*/function () {
  function Sessions(registry) {
    (0, _classCallCheck2["default"])(this, Sessions);
    this._api = registry;
    (0, _autoBind["default"])(this);
  }

  (0, _createClass2["default"])(Sessions, [{
    key: "getAllSessions",
    value: function () {
      var _getAllSessions = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(userId) {
        var result;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._api.UserSessionRegistry.List({
                  routeParams: {
                    'user_ids.user_id': userId
                  }
                });

              case 2:
                result = _context.sent;
                return _context.abrupt("return", _marshaler["default"].payloadListResponse('sessions', result));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getAllSessions(_x) {
        return _getAllSessions.apply(this, arguments);
      }

      return getAllSessions;
    }()
  }, {
    key: "deleteSession",
    value: function () {
      var _deleteSession = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(userId, session_id) {
        var result;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this._api.UserSessionRegistry.Delete({
                  routeParams: {
                    'user_ids.user_id': userId,
                    session_id: session_id
                  }
                });

              case 2:
                result = _context2.sent;
                return _context2.abrupt("return", _marshaler["default"].payloadListResponse('sessions', result));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function deleteSession(_x2, _x3) {
        return _deleteSession.apply(this, arguments);
      }

      return deleteSession;
    }()
  }]);
  return Sessions;
}();

var _default = Sessions;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJTZXNzaW9ucyIsInJlZ2lzdHJ5IiwiX2FwaSIsImF1dG9CaW5kIiwidXNlcklkIiwiVXNlclNlc3Npb25SZWdpc3RyeSIsIkxpc3QiLCJyb3V0ZVBhcmFtcyIsInJlc3VsdCIsIk1hcnNoYWxlciIsInBheWxvYWRMaXN0UmVzcG9uc2UiLCJzZXNzaW9uX2lkIiwiRGVsZXRlIl0sInNvdXJjZXMiOlsiLi4vLi4vc3JjL3NlcnZpY2Uvc2Vzc2lvbnMuanMiXSwic291cmNlc0NvbnRlbnQiOlsiLy8gQ29weXJpZ2h0IMKpIDIwMjIgVGhlIFRoaW5ncyBOZXR3b3JrIEZvdW5kYXRpb24sIFRoZSBUaGluZ3MgSW5kdXN0cmllcyBCLlYuXG4vL1xuLy8gTGljZW5zZWQgdW5kZXIgdGhlIEFwYWNoZSBMaWNlbnNlLCBWZXJzaW9uIDIuMCAodGhlIFwiTGljZW5zZVwiKTtcbi8vIHlvdSBtYXkgbm90IHVzZSB0aGlzIGZpbGUgZXhjZXB0IGluIGNvbXBsaWFuY2Ugd2l0aCB0aGUgTGljZW5zZS5cbi8vIFlvdSBtYXkgb2J0YWluIGEgY29weSBvZiB0aGUgTGljZW5zZSBhdFxuLy9cbi8vICAgICBodHRwOi8vd3d3LmFwYWNoZS5vcmcvbGljZW5zZXMvTElDRU5TRS0yLjBcbi8vXG4vLyBVbmxlc3MgcmVxdWlyZWQgYnkgYXBwbGljYWJsZSBsYXcgb3IgYWdyZWVkIHRvIGluIHdyaXRpbmcsIHNvZnR3YXJlXG4vLyBkaXN0cmlidXRlZCB1bmRlciB0aGUgTGljZW5zZSBpcyBkaXN0cmlidXRlZCBvbiBhbiBcIkFTIElTXCIgQkFTSVMsXG4vLyBXSVRIT1VUIFdBUlJBTlRJRVMgT1IgQ09ORElUSU9OUyBPRiBBTlkgS0lORCwgZWl0aGVyIGV4cHJlc3Mgb3IgaW1wbGllZC5cbi8vIFNlZSB0aGUgTGljZW5zZSBmb3IgdGhlIHNwZWNpZmljIGxhbmd1YWdlIGdvdmVybmluZyBwZXJtaXNzaW9ucyBhbmRcbi8vIGxpbWl0YXRpb25zIHVuZGVyIHRoZSBMaWNlbnNlLlxuXG5pbXBvcnQgYXV0b0JpbmQgZnJvbSAnYXV0by1iaW5kJ1xuXG5pbXBvcnQgTWFyc2hhbGVyIGZyb20gJy4uL3V0aWwvbWFyc2hhbGVyJ1xuXG5jbGFzcyBTZXNzaW9ucyB7XG4gIGNvbnN0cnVjdG9yKHJlZ2lzdHJ5KSB7XG4gICAgdGhpcy5fYXBpID0gcmVnaXN0cnlcblxuICAgIGF1dG9CaW5kKHRoaXMpXG4gIH1cblxuICBhc3luYyBnZXRBbGxTZXNzaW9ucyh1c2VySWQpIHtcbiAgICBjb25zdCByZXN1bHQgPSBhd2FpdCB0aGlzLl9hcGkuVXNlclNlc3Npb25SZWdpc3RyeS5MaXN0KHtcbiAgICAgIHJvdXRlUGFyYW1zOiB7ICd1c2VyX2lkcy51c2VyX2lkJzogdXNlcklkIH0sXG4gICAgfSlcblxuICAgIHJldHVybiBNYXJzaGFsZXIucGF5bG9hZExpc3RSZXNwb25zZSgnc2Vzc2lvbnMnLCByZXN1bHQpXG4gIH1cblxuICBhc3luYyBkZWxldGVTZXNzaW9uKHVzZXJJZCwgc2Vzc2lvbl9pZCkge1xuICAgIGNvbnN0IHJlc3VsdCA9IGF3YWl0IHRoaXMuX2FwaS5Vc2VyU2Vzc2lvblJlZ2lzdHJ5LkRlbGV0ZSh7XG4gICAgICByb3V0ZVBhcmFtczogeyAndXNlcl9pZHMudXNlcl9pZCc6IHVzZXJJZCwgc2Vzc2lvbl9pZCB9LFxuICAgIH0pXG5cbiAgICByZXR1cm4gTWFyc2hhbGVyLnBheWxvYWRMaXN0UmVzcG9uc2UoJ3Nlc3Npb25zJywgcmVzdWx0KVxuICB9XG59XG5cbmV4cG9ydCBkZWZhdWx0IFNlc3Npb25zXG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBY0E7O0FBRUE7O0FBaEJBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0lBTU1BLFE7RUFDSixrQkFBWUMsUUFBWixFQUFzQjtJQUFBO0lBQ3BCLEtBQUtDLElBQUwsR0FBWUQsUUFBWjtJQUVBLElBQUFFLG9CQUFBLEVBQVMsSUFBVDtFQUNEOzs7OzswR0FFRCxpQkFBcUJDLE1BQXJCO1FBQUE7UUFBQTtVQUFBO1lBQUE7Y0FBQTtnQkFBQTtnQkFBQSxPQUN1QixLQUFLRixJQUFMLENBQVVHLG1CQUFWLENBQThCQyxJQUE5QixDQUFtQztrQkFDdERDLFdBQVcsRUFBRTtvQkFBRSxvQkFBb0JIO2tCQUF0QjtnQkFEeUMsQ0FBbkMsQ0FEdkI7O2NBQUE7Z0JBQ1FJLE1BRFI7Z0JBQUEsaUNBS1NDLHFCQUFBLENBQVVDLG1CQUFWLENBQThCLFVBQTlCLEVBQTBDRixNQUExQyxDQUxUOztjQUFBO2NBQUE7Z0JBQUE7WUFBQTtVQUFBO1FBQUE7TUFBQSxDOzs7Ozs7Ozs7Ozt5R0FRQSxrQkFBb0JKLE1BQXBCLEVBQTRCTyxVQUE1QjtRQUFBO1FBQUE7VUFBQTtZQUFBO2NBQUE7Z0JBQUE7Z0JBQUEsT0FDdUIsS0FBS1QsSUFBTCxDQUFVRyxtQkFBVixDQUE4Qk8sTUFBOUIsQ0FBcUM7a0JBQ3hETCxXQUFXLEVBQUU7b0JBQUUsb0JBQW9CSCxNQUF0QjtvQkFBOEJPLFVBQVUsRUFBVkE7a0JBQTlCO2dCQUQyQyxDQUFyQyxDQUR2Qjs7Y0FBQTtnQkFDUUgsTUFEUjtnQkFBQSxrQ0FLU0MscUJBQUEsQ0FBVUMsbUJBQVYsQ0FBOEIsVUFBOUIsRUFBMENGLE1BQTFDLENBTFQ7O2NBQUE7Y0FBQTtnQkFBQTtZQUFBO1VBQUE7UUFBQTtNQUFBLEM7Ozs7Ozs7Ozs7OztlQVNhUixRIn0=